module.exports = __webpack_public_path__ + "img/abgc1.edf3ed4c.jpg";